import { StoreType } from '@tock/shared/utils/connect';
import { createSelector } from 'reselect';
import { dashboard } from 'types';
import _ from 'lodash';

export default createSelector(
  (state: StoreType) => state.templateInfo.templateInfos,
  (templateInfos): dashboard.SeatingTemplateInfo[] => {
    return _.filter(
      templateInfos,
      (templateInfo) => !templateInfo._deleted
    ) as dashboard.SeatingTemplateInfo[];
  }
);
